var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',{attrs:{"direction":"vertical"}},[_c('el-header',{attrs:{"height":""}},[_c('NavBar')],1),_c('el-container',{attrs:{"direction":"vertical"}},[_c('el-main',{attrs:{"height":""}},[_c('router-view')],1),_c('el-footer',{attrs:{"height":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }